{
  "Accessibility menu": "Přístupnostní menu",
  "Close": "Zavřít",
  "Content adjustments": "Úpravy obsahu",
  "Navigation adjustments": "Úpravy navigace",
  "Align Left": "Zarovnat vlevo",
  "Adjust Font Size": "Nastavit velikost písma",
  "Highlight Title": "Zvýraznit nadpis",
  "Highlight Links": "Zvýraznit odkazy",
  "Readable Font": "Čitelný font",
  "Colour adjustments": "Nastavení barev",
  "Dark Contrast": "Tmavý kontrast",
  "Light Contrast": "Světlý kontrast",
  "High Contrast": "Vysoký kontrast",
  "High Saturation": "Vysoká saturace",
  "Low Saturation": "Nízká saturace",
  "Monochrome": "Monochromatický",
  "Tools": "Nástroje",
  "Reading Guide": "Průvodce čtením",
  "Big Cursor": "Velký kurzor",
  "Increase Font Size": "Zvětšit velikost písma",
  "Decrease Font Size": "Zmenšit velikost písma",
  "Letter Spacing": "Mezery mezi písmeny",
  "Line Height": "Výška řádku",
  "Font Weight": "Tloušťka písma",
  "Dyslexia Font": "Dyslexický font",
  "Language": "Jazyk",
  "Accessibility widget": "Otevřít přístupnostní menu",
  "Accessibility Profiles": "Přístupnostní profily",
  "Cognitive Disability": "Kognitivní postižení",
  "Seizure Safe": "Bezpečné pro epilepsii",
  "Accessibility statement": "Prohlášení o přístupnosti",
  "ADHD": "ADHD",
  "Low Vision": "Low Vision",
  "Pause Animations": "Zastavit animace",
  "Reset all settings": "Obnovit nastavení",
  "Shortcut:": "Shortcut:"
}
